
import XLSX from 'xlsx'

export function download(href, title) {
  const a = document.createElement('a')
  a.setAttribute('href', href)
  a.setAttribute('target', '_blank')
  a.setAttribute('download', title)
  a.click()
}

// 过滤对象空属性
export function filterEmptyAttr(params = {}) {
  // 过滤属性为空的值
  const newParam = {}
  Object.keys(params).filter(item => {
    let value = params[item]
    if (typeof value === 'string') {
      value = value.trim()
    }
    return value || value === 0
  }).forEach((key) => {
    const value = params[key]
    newParam[key] = value
  })
  return newParam
}

// 下载excel
export function exportXlsx(downloadData = [[]], name = '') {
  const wb = XLSX.utils.book_new()
  // 返回worksheet对象
  const ws = XLSX.utils.aoa_to_sheet(downloadData, { raw: true })
  // 获取工作表中所有的单元格地址
  const cellAddresses = Object.keys(ws)

  // 循环遍历工作表中的单元格地址
  cellAddresses.forEach(address => {
    const cell = ws[address]
    // 检查单元格的数据类型是否为数字
    if (typeof cell.v === 'number' && cell.v % 1 !== 0) {
      // 设置单元格的数字格式
      cell.t = 'n' // 'n' 表示数字类型
      cell.z = '0.00' // 数字格式，保留两位小数
    }
  })
  /* add worksheet to workbook */
  XLSX.utils.book_append_sheet(wb, ws, 'sheet1')

  /* download workbook */
  const excelName = name + '_' + Date.now() + '.xls'
  XLSX.writeFile(wb, excelName)
}

// 下载excel(自动调整列宽)
export function exportXlsxFitWidth(downloadData = [[]], name = '') {
  const wb = XLSX.utils.book_new()
  // 返回worksheet对象
  const ws = XLSX.utils.aoa_to_sheet(downloadData, { raw: true })
  // 获取工作表中所有的单元格地址
  const cellAddresses = Object.keys(ws)

  // 循环遍历工作表中的单元格地址
  cellAddresses.forEach(address => {
    const cell = ws[address]
    // 检查单元格的数据类型是否为数字
    if (typeof cell.v === 'number' && cell.v % 1 !== 0) {
      // 设置单元格的数字格式
      cell.t = 'n' // 'n' 表示数字类型
      cell.z = '0.00' // 数字格式，保留两位小数
    }
  })
  /* add worksheet to workbook */
  XLSX.utils.book_append_sheet(wb, ws, name)

  const colWidths = []
  const colNames = Object.keys(downloadData[0]) // 所有列的名称数组

  // 计算每一列的所有单元格宽度
  // 先遍历行
  downloadData.forEach((row) => {
    // 列序号
    let index = 0
    // 遍历列
    for (const key in row) {
      if (colWidths[index] == null) colWidths[index] = []

      switch (typeof row[key]) {
        case 'string':
        case 'number':
        case 'boolean':
          colWidths[index].push(getCellWidth(row[key]))
          break
        case 'object':
        case 'function':
          colWidths[index].push(0)
          break
      }
      index++
    }
  })
  ws['!cols'] = []
  // 每一列取最大值最为列宽
  colWidths.forEach((widths, index) => {
    // 计算列头的宽度
    widths.push(getCellWidth(colNames[index]))
    // 设置最大值为列宽
    ws['!cols'].push({ wch: Math.max(...widths) })
  })

  /* download workbook */
  const excelName = name + '_' + Date.now() + '.xls'
  XLSX.writeFile(wb, excelName)
}

function getCellWidth(value) {
  // 判断是否为null或undefined
  if (value == null) {
    return 10
  } else if (/.*[\u4e00-\u9fa5]+.*$/.test(value)) {
    // 判断是否包含中文
    return value.toString().length * 2.1
  } else {
    return value.toString().length * 1.1
    /* 另一种方案
    value = value.toString()
    return value.replace(/[\u0391-\uFFE5]/g, 'aa').length
    */
  }
}
